// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'view-design/dist/styles/iview.css';

import Vue from 'vue';
import App from './App';
import router from './router';
import { store } from './store';
import vueResource from 'vue-resource';
import ViewUI from 'view-design';
import './assets/hamster-theme/index.less';
import './assets/hamster-theme/font/iconfont.js';

// 主题文件
import './assets/css/theme-blue.less';
import './assets/css/theme-red.less';
import './assets/css/theme-yellow.less';

import Print from './components/plugs/print';
import 'babel-polyfill';
// 引入一些自定义全局组件
import myPage from './components/common/myPage.vue';
import tableColumn from './components/common/tableColumn.vue';
import FTopMenu from './components/menu';
import apiServer from './services';

import { _EnumInit } from '../utils/enumHelper';

// 全局配置信息
import staticConfig from '@/base/staticConfig';

// filter
import { formatMoney, formatNumber, formatNumberPercent } from '@/../utils/moneyFormat.js';

Vue.use(vueResource);
Vue.use(ViewUI);
Vue.use(Print);

// 设置全局Message样式
ViewUI.Message.config({
  top: 400,
  duration: 2
});

Vue.prototype.apiServer = apiServer;

Vue.prototype.staticConfig = staticConfig;

Vue.component('FTopMenu', FTopMenu);
Vue.component('myPage', myPage);
Vue.component('tableColumn', tableColumn);

// vue-resource的全局配置
Vue.http.options.crossOrigin = true;
Vue.http.options.emulateHTTP = true;
Vue.http.options.emulateJSON = true;

Vue.config.productionTip = false;
let enumData = require('./assets/enumdata.json');
Vue.prototype.EnumHelper = _EnumInit(enumData);

Vue.filter('moneyFormat', function (v) {
  return formatMoney(v);
});
Vue.filter('numberFormat', function (v) {
  return formatNumber(v);
});
Vue.filter('percentFormat', function (v) {
  return formatNumberPercent(v);
});

/**  router  **/
router.beforeEach((to, from, next) => {
  // 当前路由，用于权限/菜单
  store.commit('activeMenu', to);
  next();
})
/**  router  **/

/** Authority **/
// directive
Vue.directive('authority', {
  bind: function (el, binding) {
    if (!store.getters.getPageAuthority(binding.value)) {
      el.disabled = true;
      el.style.display = 'none';
      el.remove();
    }
  }
});
Vue.prototype.checkBtnAuthority = function (authority, pager) {
  return store.getters.getPageAuthority(authority, pager);
}
Vue.prototype.checkBtnMenuAuthority = function (authority, pager) {
  return store.getters.getPageMenuAuthority(authority, pager);
}
/** Authority **/
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js